import axios from 'axios';
import * as types from './Orders.types';
import { showNotification } from './../../utils';
import * as loginActions from './../Login/Login.actions';
import * as selectors from './Orders.selectors';
import * as dialog from '../common/dialog';
import fileDownload from 'js-file-download';
import * as loginSelectors from './../Login/Login.selectors';

const apiUrl = process.env.REACT_APP_API_URL;

export const fetchOrders = (type) => (dispatch, getState) => {
    const pagination = selectors.getPagination(getState());
    const sort = selectors.getSort(getState());
    const search = selectors.getSearch(getState());
    const searchType = selectors.getSearchType(getState());
    const cxmlData = loginSelectors.getCxmlData(getState());

    let params = [];
    params.push('active-page=' + pagination.activePage);
    params.push('elements-per-page=' + pagination.elementsPerPage);
    params.push('sort-column=' + sort.column);
    params.push('sort-type=' + sort.type);
    params.push('search=' + search);
    params.push('search-type=' + searchType);
    params.push('cxml-email=' + cxmlData.email);

    dispatch({ type: types.FETCH_ORDERS, payload: null });
    axios.get(apiUrl + '/uthealth-order/admin-index?type=' + type + (params.length === 0 ? '' : '&' + params.join('&')),
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.FETCH_ORDERS_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            dispatch({ type: types.FETCH_ORDERS_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred', 'danger');
            }
        });
}

export const approveOrder = (history) => (dispatch, getState) => {
    const idModal = selectors.getIdModal(getState());
    const type = selectors.getType(getState());
    const isFromEmail = selectors.getIsFromEmail(getState());

    dispatch({ type: types.APPROVE_ORDER, payload: null });
    axios.post(apiUrl + '/uthealth-order/approve-order', { id: idModal },
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.APPROVE_ORDER_SUCCESS, payload: response.data });
            showNotification('Success', 'The order has been approved successfully', 'success');
            dispatch(dialog.actions.hideDialog('approve-modal'));

            if (isFromEmail) {
                history.push('/orders/' + type);
            } else {
                dispatch(fetchOrders(type));
            }
        })
        .catch((error) => {
            dispatch({ type: types.APPROVE_ORDER_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred', 'danger');
            }
        });
}

export const rejectOrder = (history) => (dispatch, getState) => {
    const idModal = selectors.getIdModal(getState());
    const type = selectors.getType(getState());
    const isFromEmail = selectors.getIsFromEmail(getState());

    dispatch({ type: types.REJECT_ORDER, payload: null });
    axios.post(apiUrl + '/uthealth-order/reject-order', { id: idModal },
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.REJECT_ORDER_SUCCESS, payload: response.data });
            showNotification('Success', 'The order has been rejected successfully', 'success');
            dispatch(dialog.actions.hideDialog('reject-modal'));

            if (isFromEmail) {
                history.push('/orders/' + type);
            } else {
                dispatch(fetchOrders(type));
            }
        })
        .catch((error) => {
            dispatch({ type: types.REJECT_ORDER_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred', 'danger');
            }
        });
}

export const exportExcel = (type, exportType) => (dispatch) => {
    dispatch({ type: types.EXPORT_EXCEL, payload: exportType });
    axios.post(apiUrl + '/uthealth-order/export-excel?type=' + type + '&exportType=' + exportType, {},
        {
            headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` },
            responseType: 'blob',
        })
        .then((response) => {
            dispatch({ type: types.EXPORT_EXCEL_SUCCESS, payload: null });

            let filename = 'Orders';
            if (type === 'pending') {
                filename = 'Pending Orders';
            } else if (type === 'approved') {
                filename = 'Approved Orders';
            } else if (type === 'rejected') {
                filename = 'Rejected Orders';
            }

            if (exportType === 1) {
                filename += ' - ACM';
            } else if (exportType === 2) {
                filename += ' - UTP';
            }

            fileDownload(response.data, filename + '.xlsx');
        })
        .catch((error) => {
            dispatch({ type: types.EXPORT_EXCEL_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred', 'danger');
            }
        });
}

export const exportOrder = (id, orderId) => (dispatch) => {
    dispatch({ type: types.EXPORT_ORDER, payload: null });
    axios.post(apiUrl + '/uthealth-order/export-order-pdf?id=' + id, { id },
        {
            headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` },
            responseType: 'blob',
        })
        .then((response) => {
            dispatch({ type: types.EXPORT_ORDER_SUCCESS, payload: null });
            fileDownload(response.data, 'Order #' + orderId + '.pdf');
        })
        .catch((error) => {
            dispatch({ type: types.EXPORT_ORDER_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred', 'danger');
            }
        });
}

export const checkSCTicket = (id) => (dispatch, getState) => {
    dispatch({ type: types.CHECK_SC_TICKET, payload: null });
    axios.post(apiUrl + '/uthealth-order/check-sc-ticket', { id },
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.CHECK_SC_TICKET_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            dispatch({ type: types.CHECK_SC_TICKET_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred', 'danger');
            }
        });
}

export const createSCTicket = () => (dispatch, getState) => {
    const idModal = selectors.getIdModal(getState());
    const type = selectors.getType(getState());
    const scTicketSelectedItems = selectors.getScTicketSelectedItems(getState());

    dispatch({ type: types.CREATE_SC_TICKET, payload: null });
    axios.post(apiUrl + '/uthealth-order/create-sc-ticket', { id: idModal, scTicketSelectedItems },
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.CREATE_SC_TICKET_SUCCESS, payload: response.data });
            showNotification('Success', 'The SC ticket has been created successfully', 'success');
            dispatch(fetchOrders(type));
            dispatch(dialog.actions.hideDialog('sc-ticket-modal'));
        })
        .catch((error) => {
            dispatch({ type: types.CREATE_SC_TICKET_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred', 'danger');
            }
        });
}

export const saveShipping = () => (dispatch, getState) => {
    const idModal = selectors.getIdModal(getState());
    const trackingNumber = selectors.getTrackingNumber(getState());
    const shipped = selectors.getShipped(getState());
    const shippingMethod = selectors.getShippingMethod(getState());
    const shippingQuantity = selectors.getShippingQuantity(getState());
    const shippingWeight = selectors.getShippingWeight(getState());
    const shippingNumPackages = selectors.getShippingNumPackages(getState());
    const type = selectors.getType(getState());

    dispatch({ type: types.SAVE_SHIPPING, payload: null });
    axios.post(apiUrl + '/uthealth-order/save-shipping', { id: idModal, trackingNumber, shipped, shippingMethod, shippingQuantity,
        shippingWeight, shippingNumPackages },
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.SAVE_SHIPPING_SUCCESS, payload: response.data });
            showNotification('Success', 'The information has been saved successfully', 'success');
            dispatch(fetchOrders(type));
            dispatch(dialog.actions.hideDialog('shipping-modal'));
        })
        .catch((error) => {
            dispatch({ type: types.SAVE_SHIPPING_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred', 'danger');
            }
        });
}

export const savePackingSlip = () => (dispatch, getState) => {
    const idModal = selectors.getIdModal(getState());
    const packingSlipMessage = selectors.getPackingSlipMessage(getState());
    const packingSlipItems = selectors.getPackingSlipItems(getState());
    const trackingNumber = selectors.getTrackingNumber(getState());
    const shippingMethod = selectors.getShippingMethod(getState());
    // const type = selectors.getType(getState());

    dispatch({ type: types.SAVE_PACKING_SLIP, payload: null });
    axios.post(apiUrl + '/uthealth-order/save-packing-slip', { id: idModal, packingSlipMessage, packingSlipItems, trackingNumber, shippingMethod },
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.SAVE_PACKING_SLIP_SUCCESS, payload: response.data });
            showNotification('Success', 'The information has been saved successfully', 'success');
            // dispatch(fetchOrders(type));
            dispatch(dialog.actions.hideDialog('packing-slip-modal'));
        })
        .catch((error) => {
            dispatch({ type: types.SAVE_PACKING_SLIP_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred', 'danger');
            }
        });
}

export const printPackingSlip = (id, orderId) => (dispatch) => {
    dispatch({ type: types.PRINT_PACKING_SLIP, payload: null });
    axios.post(apiUrl + '/uthealth-order/print-packing-slip?id=' + id, { id },
        {
            headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` },
            responseType: 'blob',
        })
        .then((response) => {
            dispatch({ type: types.PRINT_PACKING_SLIP_SUCCESS, payload: null });
            fileDownload(response.data, 'Packing Slip Order #' + orderId + '.pdf');
        })
        .catch((error) => {
            dispatch({ type: types.PRINT_PACKING_SLIP_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred', 'danger');
            }
        });
}

export const reorderProduct = (id, history) => (dispatch, getState) => {
    const cxmlData = loginSelectors.getCxmlData(getState());
    const user = loginSelectors.getUser(getState());

    let formData = new FormData();
    formData.append('id', id);
    formData.append('userId', user.id);
    formData.append('cxml_id', cxmlData.id);
    formData.append('cxml_buyer_cookie', cxmlData.buyer_cookie);
    formData.append('cxml_browser_form_post', cxmlData.browser_form_post);
    formData.append('cxml_supplier_domain', cxmlData.supplier_domain);
    formData.append('cxml_supplier_id', cxmlData.supplier_id);
    formData.append('cxml_buyer_domain', cxmlData.buyer_domain);
    formData.append('cxml_buyer_id', cxmlData.buyer_id);

    dispatch({ type: types.REORDER_PRODUCT, payload: null });
    axios.post(apiUrl + '/uthealth-order/reorder-product', formData,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.REORDER_PRODUCT_SUCCESS, payload: response.data });
            if (response.data.url !== '') {
                const variables = response.data.variables;
                localStorage.setItem('variables', JSON.stringify(variables));
                localStorage.setItem('productType', response.data.productType);
                localStorage.setItem('quantity', response.data.quantity);
                localStorage.setItem('apparelItem', JSON.stringify(response.data.apparelItem));
                localStorage.setItem('department', JSON.stringify(response.data.department));
                localStorage.setItem('url', response.data.url);
                localStorage.setItem('id', id);

                history.push(response.data.url + '/reorder');
            } else {
                showNotification('Item not found', 'This item does not exists anymore.', 'info');
            }
        })
        .catch((error) => {
            dispatch({ type: types.REORDER_PRODUCT_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred', 'danger');
            }
        });
}

export const fetchPackingSlipData = () => (dispatch, getState) => {
    const idModal = selectors.getIdModal(getState());

    dispatch({ type: types.FETCH_PACKING_SLIP_DATA, payload: null });
    axios.get(apiUrl + '/uthealth-order/fetch-packing-slip-data?id=' + idModal,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.FETCH_PACKING_SLIP_DATA_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            dispatch({ type: types.FETCH_PACKING_SLIP_DATA_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred', 'danger');
            }
        });
}

export const generatePrintReadyFile = (id) => (dispatch, getState) => {
    dispatch({ type: types.GENERATE_PRINT_READY_FILE, payload: null });
    axios.post(apiUrl + '/uthealth-order/generate-print-ready-file', { id },
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.GENERATE_PRINT_READY_FILE_SUCCESS, payload: response.data });
            showNotification('Print Ready file generated', 'The print ready file has been generated', 'success');
        })
        .catch((error) => {
            dispatch({ type: types.GENERATE_PRINT_READY_FILE_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred', 'danger');
            }
        });
}

export const setIdModal = (id) => (dispatch) => {
    dispatch({
        type: types.SET_ID_MODAL,
        payload: id
    });
}

export const setType = (type) => (dispatch) => {
    dispatch({
        type: types.SET_TYPE,
        payload: type
    });
}

export const setIsFromEmail = (value) => (dispatch) => {
    dispatch({
        type: types.SET_IS_FROM_EMAIL,
        payload: value
    });
}

export const setActivePage = (value) => (dispatch, getState) => {
    new Promise(resolve => {
        dispatch({
            type: types.SET_ACTIVE_PAGE,
            payload: value,
        });
        resolve();
    }).then(() => {
        const type = selectors.getType(getState());
        dispatch(fetchOrders(type));
    });
}

export const resetState = () => (dispatch) => {
    dispatch({
        type: types.RESET_STATE,
        payload: null,
    })
}

export const setSort = (column, type, orderType) => (dispatch) => {
    new Promise(resolve => {
        dispatch({
            type: types.SET_SORT,
            payload: { column, type }
        });
        resolve();
    }).then(() => {
        dispatch(fetchOrders(orderType));
    });
}

export const setSearch = (value) => dispatch => {
    dispatch({
        type: types.SET_SEARCH,
        payload: value,
    });
}

export const setSearchType = (value) => dispatch => {
    dispatch({
        type: types.SET_SEARCH_TYPE,
        payload: value,
    });
}

export const setTrackingNumber = (value) => dispatch => {
    dispatch({
        type: types.SET_TRACKING_NUMBER,
        payload: value,
    });
}

export const setShipped = (value) => dispatch => {
    dispatch({
        type: types.SET_SHIPPED,
        payload: value,
    });
}

export const setShippingMethod = (value) => dispatch => {
    dispatch({
        type: types.SET_SHIPPING_METHOD,
        payload: value,
    });
}

export const setShippingQuantity = (value) => dispatch => {
    dispatch({
        type: types.SET_SHIPPING_QUANTITY,
        payload: value,
    });
}

export const setShippingWeight = (value) => dispatch => {
    dispatch({
        type: types.SET_SHIPPING_WEIGHT,
        payload: value,
    });
}

export const setShippingNumPackages = (value) => dispatch => {
    dispatch({
        type: types.SET_SHIPPING_NUM_PACKAGES,
        payload: value,
    });
}

export const setPackingSlipMessage = (value) => dispatch => {
    dispatch({
        type: types.SET_PACKING_SLIP_MESSAGE,
        payload: value,
    });
}

export const checkPackingSlipItem = (id, value) => dispatch => {
    dispatch({
        type: types.CHECK_PACKING_SLIP_ITEM,
        payload: { id, value },
    });
}

export const setPackingSlipItems = (value) => dispatch => {
    dispatch({
        type: types.SET_PACKING_SLIP_ITEMS,
        payload: value,
    });
}

export const checkScTicketCheckbox = (order) => dispatch => {
    dispatch({
        type: types.CHECK_SC_TICKET_CHECKBOX,
        payload: order,
    });
}